define('home/utils/navigationUtils',[
    'jquery',
    'underscore',
    'backbone',

    'core/utils/url/serialize',

    'home/utils/sidebarUtils',
    'home/config',
], function (
    $,
    _,
    Backbone,

    serialize,

    sidebarUtils,
    config
) {
    'use strict';

    var Session;

    var leadingHashRegex = /^#/;
    var trailingSlashRegex = /\/$/;
    var outboundLinksOpenNewWindow = true;
    var routeStripper = /^[#/]|\s+$/g;

    var navigateToLogin = function () {
        $('body').html('<div class="spinner"></div>');

        var params = {
            next: 'https://disqus.com' + window.location.pathname + window.location.search,
        };

        // Lazy load Session to prevent circular dependencies
        if (!Session)
            Session = require('home/models/Session');

        var session = Session.get();
        var forum = session.forum;
        if (forum)
            params.forum = forum.shortname;

        var location = serialize('https://disqus.com/profile/login/', params);
        window.top.location = location;
    };

    var navigateToHomepage = function () {
        $('body').html('<div class="spinner"></div>');

        window.top.location = 'https://disqus.com/';
    };

    var NavigationUtils = {
        scrollPositions: {},

        // The time of the last successful call to this.navigate()
        // in ms since the Epoch
        lastNavigateTime: null,

        /**
         * Global handler for clicks on links: <a> elements with href specified
         *
         * @param {Event} evt - Click event object
         */
        handleLinkClicks: function (evt) {
            var link = evt.currentTarget;

            // If this link click will open a new window then we definitely
            // don't want to do anything here.
            if (this.shouldNotHandleLinkClick(evt, link))
                return;

            var $link = $(link);
            var href = $link.attr('href');

            // If this link starts with a # then we treat it like
            // and anchor and try to scroll to the element.
            if (leadingHashRegex.test(href) && link.hash) {
                this.scrollToElement(evt);
                return;
            }

            // Else, if we are in the sidebar or we don't have an internal
            // route for this link and this link does not point to a page that
            // is on our network such as publishers.disqus.com, we simply add a
            // `target='_blank'` attribute and let the link open in a new tab.
            if (sidebarUtils.isSidebar() || !(this.matchesRoute(link) || this.isInternalLink(link))) {
                // If the link includes `data-link-out` attribute
                // we set the value of the attribute as the href.
                var redirectLink = $link.attr('data-link-out');
                if (redirectLink) {
                    var original = $link.attr('href');
                    // Set the link back to the orignal href after .5 second
                    _.delay(function () {
                        $link.attr('href', original);
                    }, 500);
                    $link.attr('href', redirectLink);
                }

                $link.attr('target', '_blank');
                return;
            } else if (this.isInternalLink(link) && !this.matchesRoute(link)) {
                // If this a link to our own network but not on the Home app,
                // do nothing so the link can work as it is as expected.
                return;
            }

            // Finally, we have a guarantee that we know how to handle this link
            // and that we should handle this link. At this point we just need to
            // cause navigation to occur.
            evt.preventDefault();
            this.navigate(link, true);
        },

        coerceTrailingSlash: function (loc) {
            if (trailingSlashRegex.test(loc.pathname))
                return;

            this.navigate(
                decodeURI(loc.pathname + '/' + loc.search + loc.hash),
                { replace: true }
            );
        },

        getFragmentFromLink: function (link) {
            // Basically entire function copied form Backbone.History.getFragment
            // but uses `link` instead of `location`.
            var fragment = decodeURI(link.pathname + link.search);
            var root = config.appRoot.replace(trailingSlashRegex, '');
            if (!fragment.indexOf(root))
                fragment = fragment.slice(root.length);
            return fragment.replace(routeStripper, '');
        },

        /**
         * This function will return true for links to any subdomain of the
         * current application domain.
         *
         * @param  {Object} link An object with at least the properties {host}
         * @returns {boolean}
         */
        isInternalLink: function (link) {
            var appHost = window.location.host;
            return appHost === link.host ||
                link.host.indexOf(appHost) > 1;  // include subdomains
        },

        /**
         * Is this an inbound link? An inbound link is one that does not require a
         * page reload.
         * @param  {Object}  link An object with at least the properties {href, pathname, search, hash}
         * @returns {boolean}
         */
        isInbound: function (link) {
            return (
                // if href begins with hash, it must be inbound
                link.href[0] === '#' ||
                this.matchesRoute(link)
            );
        },

        /**
         * Is the given link a path that our router handles?
         *
         * We use this method instead of Backbone.history.loadUrl or
         * the return value from Backbone.history.navigate because
         * both of those methods will update the browser's URL =/
         *
         * @param  {DOMElement} link - An anchor element to test
         * @returns {boolean}
         */
        matchesRoute: function (link) {
            // If the host (domain and port) does not match, then this link
            // should not be considered a match no matter what.
            if (link.host !== window.location.host)
                return false;

            var frag = this.getFragmentFromLink(link);
            return _.any(Backbone.history.handlers, function (handler) {
                return handler.route.test(frag);
            });
        },

        shouldNotHandleLinkClick: function (event, link) {
            return (
                // an earlier handler called preventDefault() on the event
                event.isDefaultPrevented() ||
                // the link was given a target attribute
                $(link).attr('target') ||
                // a modifier key was pressed while clicking link
                this.hasModifierKey(event) ||
                // click occured within a react subview, which does not have
                // the ability to preventDefault before evt is caught here
                $(link).closest('[data-view-type=react]').length
            );
        },

        hasModifierKey: function (event) {
            return (
                event.ctrlKey ||  // For Windows and Linux
                event.metaKey || // For OS X
                event.shiftKey || // For new window
                event.altKey  // God knows what
            );
        },

        linkClickChangesPage: function (event, link) {
            // links that open in a new window do not change the page
            if ($(link).attr('target') === '_blank')
                return false;

            // links that had a modifier key pressed open in a new
            // window and so do not change the page
            if (this.hasModifierKey(event))
                return false;

            // inbound links do not change the page
            // and if the link is not inbound it must be outbound
            // and so whether or not it opens in a new page
            // and consequently does not change the page is
            // determined by outboundLinksOpenNewWindow
            return !this.isInbound(link) && !outboundLinksOpenNewWindow;
        },

        // Scroll to the target element so that it goes up
        // to the top of the page but just below the Home nav bar
        scrollToElement: function (evt) {
            if (!evt)
                return;

            var selector = $(evt.currentTarget).attr('href');
            var $el = $(selector);

            if (!$el.length)
                return;

            evt.preventDefault();

            var $header = $('header.site-nav--wrapper');
            var headerHeight = $header.height();

            $('body').scrollTop($el.offset().top - headerHeight);
        },

        /*
         * Wrapper around Backbone.history.navigate
         */
        navigate: function (fragment, options) {
            options = options || {};
            var trigger = options.trigger;
            var hash = '';
            var returnVal;

            // If fragment is actually a link
            if (fragment.pathname) {
                hash = fragment.hash;
                fragment = this.getFragmentFromLink(fragment);
            }

            // If we get here and we aren't on the /by/ profile path,
            // then rewrite the URL to be correct. (backwards compatibility)
            if (fragment.indexOf('home/user') !== -1)
                fragment = fragment.replace('home/user', 'by');

            this.storeScrollPosition();

            // lastNavigateTime needs to be updated before call to .navigate() because
            // code triggered by .navigate() may rely on it.
            // Do not record if options.replace because replacing the url is not a true
            // navigation (cannot go back).
            if (!options.replace)
                NavigationUtils.lastNavigateTime = $.now();

            returnVal = Backbone.history.navigate(fragment + hash, options);

            if (trigger)
                this.applyScrollPosition();

            return returnVal;
        },

        notFoundRouteHandler: function () {
            NavigationUtils.navigate('/', { trigger: true, replace: true });
        },

        storeScrollPosition: function () {
            this.scrollPositions[Backbone.history.getFragment()] = window.pageYOffset || window.document.documentElement.scrollTop;
        },

        applyScrollPosition: function () {
            window.scrollTo(0, this.scrollPositions[Backbone.history.getFragment()]);
        },

        /*
         * Error codes at http://disqus.com/api/docs/errors/
         * Error code 2 occurs on certain calls (ex: users/details) that could
         * take a user param, or use the current logged-in user if none given.
         * These return error code 2 with a message along the lines of
         * "must specify user or have an authenticated user".
         */
        navigateToLoginOnAuthFail: function (xhr) {
            // When aborting, it seems that responseText is undefined
            // so don't assume it'll always exist
            if (!xhr.responseText)
                return xhr;

            try {
                var response = JSON.parse(xhr.responseText);
                if (
                    window.location.pathname !== '/home/welcome' &&
                    (
                        response.code === 4 ||
                        response.code === 2 && /authenticate/.test(response.response)
                    )
                )
                    navigateToLogin();
            } catch (err) {
                // Invalid JSON is acceptable as this is an api error handler.
                // Do nothing.
            }

            return xhr;
        },

        navigateToLogin: navigateToLogin,
        navigateToHomepage: navigateToHomepage,

    };

    return NavigationUtils;
});

